// extracted by mini-css-extract-plugin
export default {"FullViewPage":"EmployeeTaskFullView_FullViewPage__r2f2y"};